/**
 * This component uses Portable Text to render a post body.
 *
 * You can learn more about Portable Text on:
 * https://www.sanity.io/docs/block-content
 * https://github.com/portabletext/react-portabletext
 * https://portabletext.org/
 *
 */

import React from 'react';
import { PortableText, type PortableTextBlock } from 'next-sanity';

import { portableTextComponents } from './PortableTextComponents';

export function CustomPortableText({
  className,
  value,
  style,
  maxLines,
}: {
  className?: string;
  value: PortableTextBlock[];
  style?: React.CSSProperties;
  maxLines?: number;
}) {
  const lineClampClass = maxLines ? `line-clamp-${maxLines}` : '';

  return (
    <div className={['space-y-4', lineClampClass, className].filter(Boolean).join(' ')} style={style}>
      <PortableText components={portableTextComponents} value={value} />
    </div>
  );
}
